export enum messagesEnum {
  SAVE_BEFORE_LEAVE = 'Deseja salvar o cálculo antes de sair?',
  LOADING = 'Aguarde, estamos carregando...',
  CONNECT = 'Aguarde, estamos conectando...',
  LOADING_SUCCESS_USER_NOT_FOUND_ON_RANGE = 'Nenhum usuário encontrado no período!',
  LOADING_SUCCESS_USER = 'Usuários carregados com sucesso!',
  LOADING_SUCCESS = 'Carregado com sucesso!',
  LOADING_ERROR = 'Erro ao carregar!',
  ACCOUNT_SAVE = 'Aguarde, estamos salvando o cálculo!',
  ACCOUNT_SAVE_SUCESS = 'Cálculo salvo com sucesso!',
  ACCOUNT_SAVE_ERROR = 'Erro ao salvar cálculo!',
  ACCOUNT_DELETE_ERROR = 'Erro ao remover cálculo!',
}
